export default __webpack_public_path__ + "static/media/pingo.289010d5.jpg";